import React from "react";

const GuideCTA = () => {
  return (
    <div className="guide-cta-wrapper">
      <a href="https://aqualens.in/pages/wear-contact-lenses" className="guide-cta">
        <span>View Our Guide Here</span>
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.4299 6.56818L20.4999 12.6382L14.4299 18.7082"
            stroke="#1B1B1B"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.5 12.6382H20.33"
            stroke="#1B1B1B"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
    </div>
  );
};

export default GuideCTA;
